// src/components/auth/PasswordResetModal.jsx
import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';

const PasswordResetModal = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    // Trigger password reset email via Supabase
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) {
      // Always display a generic message to avoid revealing user existence
      setError('If an account exists with that email, a reset link will be sent.');
    } else {
      setSubmitted(true);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        {submitted ? (
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-green-600 mx-auto mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <h2 className="text-2xl font-bold mb-2">Check Your Inbox</h2>
            <p className="text-gray-700 mb-4">
              If an account with that email exists, you will receive a link to reset your password.
            </p>
            <button
              onClick={onClose}
              className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
            >
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h2 className="text-2xl font-bold text-center">Reset Your Password</h2>
            {error && <div className="text-red-600 text-center">{error}</div>}
            <div>
              <label htmlFor="reset-email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                id="reset-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-green-400"
                required
              />
            </div>
            <button type="submit" className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors">
              Send Reset Link
            </button>
            <div className="text-center">
              <button type="button" onClick={onClose} className="text-green-600 hover:underline">
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PasswordResetModal;
